import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { DsDropdownComponent } from "./ds-dropdown.component";
import { DsSelectorComponentsModule } from "../ds-selector-components/ds-selector-components.module";
import { DsIconModule } from "../ds-icon/ds-icon.module";
@NgModule({
  declarations: [DsDropdownComponent],
  imports: [CommonModule, DsSelectorComponentsModule, DsIconModule],
  exports: [DsDropdownComponent, DsSelectorComponentsModule],
})
export class DsDropdownModule {}
